import * as BaseTypes from './types';

const triggerEssentialReload = () => ({ type: BaseTypes.APP_ESSENTIAL_RELOAD });

export { triggerEssentialReload };
